import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalKeyboardShortcutsStatus: ExperimentalQueries['experimentalKeyboardShortcutsStatus'] =
	(_, {}, { network }) => {
		const url = '/wiki/rest/confluenceshortcuts/latest/enabled';

		return network
			.cfetch(url, {
				method: 'GET',
			})
			.then((res) => res.text())
			.then((data) => ({ enabled: data === 'true' }));
	};
